import { render, staticRenderFns } from "./Class.vue?vue&type=template&id=34a5c538&"
import script from "./Class.js?vue&type=script&lang=js&"
export * from "./Class.js?vue&type=script&lang=js&"
import style0 from "./Class.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports